<template>
  <div
    id="map-wrapper"
    :style="{ height: height + 'vh' }"
    style="position: relative; border: 1px solid #d8dde3"
  >
    <div class="infos">
      <div>
        <div class="ui statistic" style="padding: 0 10px">
          <div>
            时间 :
            <span class="value">
              {{ cur_time }}
            </span>
          </div>
        </div>
      </div>
      <div class="infos_checkbox" v-show="false">
        <div style="text-align: right">
          <el-button @click="showSet = !showSet" type="primary" size="small">
            配置
            <i
              v-show="showSet == true"
              class="el-icon-arrow-up el-icon--right"
            ></i>
            <i
              v-show="showSet == false"
              class="el-icon-arrow-down el-icon--right"
            ></i>
          </el-button>
        </div>

        <div
          v-show="showSet"
          style="padding: 5px 10px 5px 5px; border-radius: 10px"
          :class="[mode == 'current' ? 'set_infos1' : 'set_infos2']"
        >
          <el-checkbox
            v-model="showOff"
            style="display: inline-block; height: 3vh"
            >显示离线设备</el-checkbox
          >
          <el-checkbox
            v-model="showName"
            style="display: inline-block; height: 3vh"
            >显示微站名称</el-checkbox
          >
          <el-checkbox
            v-model="showCurrentStation"
            style="display: inline-block; height: 3vh"
            >标记当前微站</el-checkbox
          >
          <el-checkbox
            v-model="showGFName"
            style="display: inline-block; height: 3vh"
            >显示标站名称</el-checkbox
          >
          <el-checkbox
            v-model="showGridName"
            style="display: inline-block; height: 3vh"
            >显示热点网格名称</el-checkbox
          >

          <div style="font-size: 1.5vh">
            <span class="demonstration">网格透明度</span>
            <el-slider v-model="gridOpacity"></el-slider>
          </div>

          <div id="r-result">
            <!-- <input type="text" id="suggestId" value="" style="width:150px;" /> -->
            <el-input
              size="mini"
              value=""
              id="suggestId"
              placeholder="请输入内容"
              prefix-icon="el-icon-search"
            >
            </el-input>
          </div>
          <div
            id="searchResultPanel"
            style="
              border: 1px solid #c0c0c0;
              width: 150px;
              height: auto;
              display: none;
              z-index: 100;
            "
          ></div>
        </div>
        <!-- <el-checkbox v-model="pointHide" style="display: inline-block;height: 3vh">隐藏散点</el-checkbox> -->
      </div>
    </div>
    <base-map
      @map="initMap"
      :height="height"
      :map-id="main_map"
      :showOldborder="showOldborder"
    ></base-map>

    <color-bar
      @changeMapColor="changeMapColor"
      :data-type="data_type"
      :min="min"
      :max="max"
      :barMode="barMode"
    ></color-bar>

    <station-dialog
      v-if="stationDialogVisible"
      :stationDialogVisibleP="stationDialogVisible"
      :station-dialog-type="station_dialog_type"
      :station="chooseStation"
      :data-type="data_type"
      :time-type="time_type"
      :valueTime="timeRange"
      :calied_type="calied_type"
      @changeVisible="changeVisible"
    >
    </station-dialog>

    <big-station-dialog
      v-if="showBigStationDialog"
      :station="chooseStation"
      :timeType="time_type"
      :dataType="data_type"
      :showChilds="showChilds"
      :height="height"
      :map="map"
      :valueTime="timeRange"
      :calied_type="calied_type"
      @changeBigStationDialogShow="changeBigStationDialogShow"
    />
    <!-- 溯源 -->
    <SuYuan
      :dialogSuyuanVisible.sync="dialogSuyuanVisible"
      @parentControlClose="parentControlClose"
      :sn="gf_sn"
      :level="gf_level"
      :gf_name="gf_name"
    />

    <aermodCard
      v-if="showAermodLayer && chooseTrackerStation"
      :station="chooseTrackerStation"
      :pollutionSourceData="areaModeList"
      :data_type="data_type"
    >
      
    </aermodCard>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  split_color,
  type_name,
  zoomCircleSize,
  color_max,
  split_color_pm10_pm25
} from "@/utils/common.js";
import {
  openMapWindow,
  addMarker,
  getTimeByType,
  calcMapcolor,
  getWindRecentTime,
  isCheckNumber
} from "@/utils/util";
import { getRegion, getGrid, getWindFromEarth, getGrids, getRecent24hourPolluteSource } from "@/api/api";

import {
  text_options_high,
  text_options_name,
  region_text_options,
  options_bubble,
  options_circle,
  grid_options_name
} from "@/options/mapv_options";
import BaseMap from "./BaseMap.vue";
import ColorBar from "./ColorBar.vue";
import StationDialog from "./StationDialog.vue";
import SuYuan from "./suyuan/index.vue";
import BigStationDialog from "./BigStationDialog";
import aermodCard from '@/components/edf/aermodCard'
import HighCharts from "highcharts";
import { drawGrid, drawWindLayer, searchMap, drawTile } from "@/utils/ext";
import ImgOverLayer from "@/utils/img_overlay";
import { openStationWindow, getInstance } from "@/utils/open_station_window";
import { openGfinfoWindow, closeAll } from "@/utils/gfMarkerInfo";
import FileSaver from "../utils/FileSaver";
import { stiltLayer } from '@/utils/stiltLayer'
import AermodLayer from '@/utils/aermodLayer'

export default {
  data() {
    return {
      dialogSuyuanVisible: false,
      gf_sn: "",
      gf_level: "",
      gf_name: "",
      main_map: "map",
      map: null,
      barMode: "ord",
      // 配置项
      // showOff:false,
      // showName:true,
      // showCurrentStation:true,
      // showGridName:true,
      // gridOpacity: 70,
      // showGFName: true,

      showSet: false,
      pointHide: false,

      stationDialogVisible: false,
      station_dialog_type: "station",
      chooseStation: {},

      chooseTrackerStation: null,

      now_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      time_sec: "", // 更新实时时间

      // 区域边界列表
      poly_list: [],
      poly_list_jiezhen: [],

      gf_point_list: [], // 官方点列表
      pollute_source_list: [], // 污染源列表

      // 色带类型
      range_color: split_color,
      colorType: "choropleth",

      draw_data: [],
      draw_data_off: [],

      // 数据集
      dataSetOff: [],
      quxian_name_set: [],
      jiezhen_name_set: [],
      dataSet: [],
      quxianDataSet: [],
      jiezhenDataSet: [],
      quxianNameDataSet: [],
      jiezhenNameDataSet: [],
      windRoseDirectionDataSet: [],
      windRoseSpeedDataSet: [],

      // 图层
      mapvLayer: "",
      textMapLayer_high: "",
      textMapLayerName: "",
      quxianMaplayer: "",
      jiezhenMaplayer: "",
      quxianNameMapLayer: "",
      jiezhenNameMapLayer: "",
      currStationMaplayer: "",
      mapvLayerOff: "",
      mapvLayerNameOff: "",

      windRoseDirectionLayer: "",

      windRoseSpeedLayer: "",

      cirSize: 3,
      debouncedQuxian: "",
      debouncedJiezhen: "",

      count: 0, // 数据个数

      all_grid: [],
      canvasLayer: "",
      grid_fill: false,
      // cur_time: 0, // 数据时间
      grid_type: "grid", //网格类型(1x1, 3x3)

      mode: "current",
      windLayer: "",
      tileLayer: "",
      last_wind_t: "",

      grids1: [],
      grids3: [],
      grid1_child: [],
      grid5_child: [],
      grid_zoom_change: 11,
      windRoseLayer: null,
      colorBarId: 1,
      showBigStationDialog: false,
      curLipuValue: "31",
      showData: [],

      polluteSourceData: [],

      areaModeList: []
    };
  },
  components: {
    BaseMap,
    ColorBar,
    StationDialog,
    BigStationDialog,
    SuYuan,
    aermodCard
  },
  props: [
    "height",
    "mapData", // 数据
    "realData", // 实时数据
    "quxianData",
    "jiezhenData",
    "mapType", // 地图类型

    "gfData",
    "isShowCircle",
    "circleR",
    "lock", // 色值锁定
    "chooseStationChart", // 当前点
    "min",
    "max",
    "point_size_rate",
    "showWindLayer",
    "showPolluteSourceLayer",
    "gridInterpImgTransparency",
    "showGridInterpImg",
    "showCarLayer",
    "car_point_filter",
    "showWindRoseMap",
    "chooseGrid",
    "gridDialogVisible",
    "showWz",
    "showGfOutline",
    "showOldborder",
    "windColor",

    "showOff",
    "showName",
    "showLipuChart",
    "lipuValue",
    "showCurrentStation",
    "showGFName",
    "showGridName",
    "gridOpacity",

    "isPollution",

    "channels",
    "trackMode",
    "trackTransparency",
    "trackTimeRange",
    "trackCustomTimeMode",
    "trackTimeMode",

    "showAermodLayer",
    "aermodRoundType",
    "aermodCircleRound"

  ],
  watch: {
    trackTransparency() {
      if (this.stiltLayer) {
        this.stiltLayer.setOptions({
          transparency: this.trackTransparency
        })
      }
    },
    trackMode() {
      if (this.trackMode) {
        this.stiltLayer = stiltLayer(this.map)
        this.stiltLayer.setOptions({
          transparency: this.trackTransparency
        })
      }else {
        this.showAermodLayer = false
        this.chooseTrackerStation = null
        this.stiltLayer.destroy()
        this.stiltLayer = null
        // this.map.removeOverlay(this.stiltLayer.canvasLayer)
      }
    },
    showAermodLayer() {
      if (this.showAermodLayer) {
        this.aermodLayer = new AermodLayer(this.map, [], {sensorType: this.data_type}, (data)=>{
          this.areaModeList = data
        })
      }else {
        this.chooseTrackerStation = null
        this.aermodLayer.destroy()
        this.aermodLayer = null
        // this.map.removeOverlay(this.stiltLayer.canvasLayer)
      }
    },
    windColor() {
      this.windLayerChange();
    },
    isShowCircle() {
      this.updateGf();
    },
    currMapStyle: {
      handler() {
        if (this.currMapStyle != "normal") {
          this.currStationMaplayer.update({
            options: {
              strokeStyle: "white"
            }
          });
          this.currStationMaplayerOff.update({
            options: {
              strokeStyle: "white"
            }
          });
        } else {
          this.currStationMaplayer.update({
            options: {
              strokeStyle: "#091939"
            }
          });
          this.currStationMaplayerOff.update({
            options: {
              strokeStyle: "#091939"
            }
          });
        }
        // if (this.$route.query.map == 1){
        //   this.currStationMaplayer.update({options:{
        //     strokeStyle: '#091939',
        //   }})
        //   this.currStationMaplayerOff.update({options:{
        //     strokeStyle: '#091939',
        //   }})
        // }
      }
      // immediate: true
    },
    mapType() {
      if (this.mapType == "point") {
        this.pointLayers();
        this.quxianMaplayer.hide();
        this.jiezhenMaplayer.hide();
        this.jiezhenNameMapLayer.hide();
        this.quxianNameMapLayer.hide();
        this.removeGrid();
      }
      if (this.mapType == "quxian") {
        this.drawRegion("quxian");
        this.pointLayers(false);
        this.removeGrid();
      }
      if (this.mapType == "jiezhen") {
        this.drawRegion("jiezhen");
        this.pointLayers(false);
        this.removeGrid();
      }
      if (this.mapType == "grid") {
        this.pointLayers(false);
        this.quxianMaplayer.hide();
        this.jiezhenMaplayer.hide();
        this.jiezhenNameMapLayer.hide();
        this.quxianNameMapLayer.hide();
        this.map.addEventListener(
          "click",
          function(r) {
            this.openGridInfo(r);
          }.bind(this)
        );
        this.initGrid();
      }
    },
    car_point_filter() {
      this.getCarLayer();
    },
    showWindLayer() {
      this.windLayerChange();
    },
    showPolluteSourceLayer() {
      this.updatePolluteSourceLayer();
    },
    gridInterpImgTransparency() {
      if (this.showGridInterpImg && this.groundOverlay) {
        this.groundOverlay.setOpacity(this.gridInterpImgTransparency)
      }
    },
    showGridInterpImg() {
      this.updateGridInterpImg()
    },
    showCarLayer() {
      this.getCarLayer();
    },
    time_type() {
      var self = this;
      closeAll(this.map);
      this.$emit("update:showLipuChart", false);
      if (this.time_type == "real") {
        this.time_sec = setInterval(function() {
          self.now_time = self.$moment().format("YYYY-MM-DD HH:mm:ss");
        }, 1000);
      } else {
        clearInterval(this.time_sec);
      }
    },
    mapData() {
      if (this.mapType == "point") {
        this.drawMap();
      }
      if (this.mapType == "grid") {
        this.gridFillData(true);
      }
    },
    quxianData() {
      if (this.mapType == "quxian") {
        this.updateRegionData("quxian");
      }
    },
    jiezhenData() {
      if (this.mapType == "jiezhen") {
        this.updateRegionData("jiezhen");
      }
    },
    cirSize() {
      this.mapvLayer.update({
        options: {
          size: this.cirSize
        }
      });
      this.mapvLayerOff.update({
        options: {
          size: this.cirSize
        }
      });
      this.currStationMaplayer.update({
        options: {
          size: this.cirSize + 1
        }
      });
      this.textMapLayer_high.update({
        options: {
          size: this.cirSize
        }
      });
      if (this.windRoseSpeedLayer) {
        this.windRoseSpeedLayer.update({
          options: {
            width: this.cirSize * 8,
            height: this.cirSize * 8
          }
        });
      }
      if (this.windRoseDirectionLayer) {
        this.windRoseDirectionLayer.update({
          options: {
            width: this.cirSize * 8,
            height: this.cirSize * 8
          }
        });
      }
    },
    showOff() {
      if (this.showOff) {
        this.mapvLayerOff.show();
        this.changeCirSize();
        this.currStationMaplayerOff.show();
      } else {
        this.mapvLayerOff.hide();
        this.mapvLayerNameOff.hide();
        this.currStationMaplayerOff.hide();
      }
    },
    showName() {
      if (this.showName) {
        this.changeCirSize();
      } else {
        this.textMapLayerName.hide();
        this.mapvLayerNameOff.hide();
      }
    },
    showLipuChart() {
      if (this.showLipuChart) {
        this.changLipuChartShow();
      } else {
        closeAll(this.map);
      }
    },
    lipuValue(n) {
      this.curLipuValue = n + "";
      if (this.showLipuChart) {
        closeAll(this.map);
        this.changLipuChartShow();
      }
    },
    showGridName() {
      if (this.canvasLayer) {
        this.update();
      }
    },
    gfData() {
      this.updateGf();
    },
    poly_list() {
      this.debouncedQuxian();
    },
    poly_list_jiezhen() {
      this.debouncedjiezhen();
    },
    showCurrentStation() {
      if (this.showCurrentStation) {
        this.drawCurrentStation();
      } else {
        this.currStationMaplayer.hide();
      }
    },
    chooseStationChart() {
      if (this.showCurrentStation) {
        this.drawCurrentStation();
      }
    },
    pointHide() {
      if (this.pointHide) {
        this.mapvLayer.hide();
      } else {
        this.mapvLayer.show();
      }
    },
    min() {
      this.changeMapColor(this.colorType, this.range_color);
      this.getCarLayer();
    },
    max() {
      this.changeMapColor(this.colorType, this.range_color);
      this.getCarLayer();
    },
    point_size_rate() {
      this.mapvLayer.update({
        options: {
          point_size_rate: this.point_size_rate
        }
      });
    },
    line_t() {
      // this.cur_time = this.$moment(this.line_t).format('YYYY-MM-DD HH')
      this.windLayerChange();
      this.getCarLayer();
      this.updateGridInterpImg()
      if (this.trackMode && this.chooseTrackerStation) {
        if (this.trackCustomTimeMode) {
          this.stiltLayer.getData(this.chooseTrackerStation, this.trackCustomTimeMode, this.trackTimeRange, this.trackTimeMode)
        }else {
          this.stiltLayer.getData(this.chooseTrackerStation, this.trackCustomTimeMode, this.line_t, this.trackTimeMode)
          this.aermodLayer.getData(this.chooseTrackerStation, this.line_t, this.aermodRoundType, this.aermodCircleRound)
        }
      }
    },
    trackTimeRange() {
      if (this.trackMode && this.chooseTrackerStation) {
        if (this.trackCustomTimeMode) {
          this.stiltLayer.getData(this.chooseTrackerStation, this.trackCustomTimeMode, this.trackTimeRange, this.trackTimeMode)
        }else {
          this.aermodLayer.getData(this.chooseTrackerStation, this.line_t, this.aermodRoundType, this.aermodCircleRound)
        }
      }
    },
    trackTimeMode() {
      if (this.trackMode && this.chooseTrackerStation) {
        if (this.trackCustomTimeMode) {
          this.stiltLayer.getData(this.chooseTrackerStation, this.trackCustomTimeMode, this.trackTimeRange, this.trackTimeMode)
        }else {
          this.aermodLayer.getData(this.chooseTrackerStation, this.line_t, this.aermodRoundType, this.aermodCircleRound)
        }
      }
    },
    showWindRoseMap() {
      this.drawWindRose("");
    },
    gridOpacity() {
      this.update();
    },
    grids() {
      this.update();
    },
    gridDialogVisible() {
      if (!this.gridDialogVisible) {
        this.grid1_child = null;
      }
    },
    showWz() {
      this.drawMap();
    },
    showGfOutline() {
      this.updateGf();
    },
    colorBarId() {
      this.updateGf();
      this.getCarLayer();
      this.$emit(
        "update:colorType",
        this.colorBarId == 2 ? "dynamic" : "static"
      );
    },
    showGFName() {
      this.updateGf();
    },
    circleR() {
      this.updateGf();
    },
    cur_time() {
      closeAll(this.map);
      this.$emit("update:showLipuChart", false);
      this.$store.commit("setCurTime", this.cur_time);
    },
    data_type() {
      this.getCarLayer();
      if (this.data_type == "pm10_pm25") {
        this.barMode = this.data_type;
      } else {
        this.barMode = "ord";
      }
      this.updatePolluteSourceLayer();
      this.updateGridInterpImg()
    }
  },
  computed: {
    ...mapState([
      "stations",
      "gf_stations",
      "projectInfo",
      "currMapStyle",
      "zhGroupInfo",
      "timeRange",
      "line_t",
      "data_type",
      "time_type",
      "calied_type",
      "showChart",
      "loadSnapStatus",
      "userPowers"
    ]),
    cur_time() {
      return getTimeByType(this.line_t / 1000, this.time_type);
    },
    grids() {
      return {
        grid3: this.grids3,
        grid1: this.grid1_child,
        grid5: this.grid5_child
      };
    },
    zoom() {
      if (this.map) {
        return this.map.getZoom();
      } else {
        return 0;
      }
    },
    intensity() {
      const data_type = this.data_type.split("_pollution")[0];
      return new colorIntensity.getIntensity({
        dataType: data_type,
        max: this.max,
        min: this.min,
        colorType: this.colorBarId == 2 ? "dynamic" : "static"
      });
    },
    dataTypePm() {
      return this.data_type.split("_")[0];
    },
    showChilds() {
      let showChilds = 0;
      if (this.$model == 1) {
        showChilds = 1;
      }
      return showChilds;
    },
    showWind() {
      return (
        this.userPowers.controls &&
        this.userPowers.controls.find(x => x.name === "windPollutionStatistics")
      );
    }
  },
  mounted() {
    this.getInstance(this);
  },
  methods: {
    getInstance,
    changeBigStationDialogShow(v) {
      this.showBigStationDialog = v;
    },
    update() {
      let grid_info = drawGrid(
        this.grids,
        this.map,
        this.ctx,
        this.data_type,
        this.grid_fill,
        this.showGridName,
        this.zoom,
        this.cirSize,
        this.grid_zoom_change,
        this.gridOpacity / 100,
        this.chooseGrid
      );
      this.all_grid = grid_info.all_grid;
    },
    changeVisible(v) {
      this.stationDialogVisible = v;
    },
    boundsShow(smlng, bglng, smlat, bglat) {
      var listhide = [], //隐藏的数据
        listshow = []; //显示的数据
      let data_type = this.data_type;
      if (this.data_type.includes("channels")) {
        data_type = this.channels;
      }
      const mapData = this.mapData.filter(
        item => item.data[data_type] !== null
      );
      for (var i = 0, lengths = mapData.length; i < lengths; i++) {
        //如果marker的经度 小于可视范围的最大经度大于可视范围的最小经度--
        //并且marker的纬度 小于可是范围的最大纬度大于可视范围的最小纬度--则需要显示
        if (
          smlng < mapData[i].Lng &&
          mapData[i].Lng < bglng &&
          smlat < mapData[i].Lat &&
          mapData[i].Lat < bglat
        ) {
          //显示
          // if(this.mapData[i].data.pm10){
          //    //显示
          //   listshow.push(this.mapData[i]);
          // }
          listshow.push(mapData[i]);
        } else {
          //不显示
          listhide.push(mapData[i]);
        }
      }
      //返回显示的数量与隐藏的数量
      return {
        listshow: listshow,
        listhide: listhide
      };
    },

    changLipuChartShow() {
      let tempObj = {};
      var bounds = this.map.getBounds(),
        SouthWest = bounds.getSouthWest(),
        NorthEast = bounds.getNorthEast();
      var data = this.boundsShow(
        SouthWest.lng,
        NorthEast.lng,
        SouthWest.lat,
        NorthEast.lat
      );
      if (!data.listshow.length) {
        return this.$message({
          message: "可视区域点位为0个！",
          type: "warning"
        });
      }
      console.log(this.cur_time);
      if (data.listshow.length < 21 && data.listshow.length > 0) {
        // if(this.time_type === 'hour' || this.time_type === 'day' || this.time_type === 'min'){
        let searchTime = this.$moment(this.line_t).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        //  if(this.time_type !== 'day'){
        //    searchTime = this.$moment(this.cur_time).format('YYYY-MM-DD HH:mm:ss')
        //  }else{
        //    searchTime = this.cur_time
        //  }
        data.listshow.forEach(element => {
          tempObj = {
            point: {
              lat: element.Lat,
              lng: element.Lng
            },
            time: searchTime,
            sn: element.DevSN,
            // sn:'B003-0019',
            data_type: this.time_type,
            curLipuValue: this.curLipuValue
          };
          if (element.DevType === "029") {
            openGfinfoWindow(tempObj, map);
          }
        });
        // }else{
        //   this.$message({
        //     message: '该统计维度无粒谱图',
        //     type: 'warning'
        //   });
        //   this.$emit('update:showLipuChart',false);
        // }
      } else {
        // checkbox 不能勾选
        this.$message({
          message: "可视区域点位超过20个！",
          type: "warning"
        });

        this.$emit("update:showLipuChart", false);
      }
    },
    initMap(map) {
      var self = this;
      if (this.currMapStyle != "normal") {
        options_circle.strokeStyle = "white";
      }
      searchMap(map);
      map.addEventListener("zoomend", this.changeCirSize);
      let options = {
        splitList: this.range_color[this.data_type.slice(0, 4)],
        size: this.cirSize,
        draw: this.colorType,
        point_size_enable: this.point_size_enable,
        point_size_rate: this.point_size_rate,
        zIndex: 2,
        methods: {
          click: function(item) {
            // 点击事件，返回对应点击元素的对象值
            self.clickMapv(item);
          }
        }
      };

      let optionOff = {
        fillStyle: "#666666",
        zIndex: 1,
        methods: {
          click: function(item) {
            // 点击事件，返回对应点击元素的对象值
            self.clickMapv(item);
          }
        },
        size: this.cirSize,
        draw: "simple"
      };

      var wind_options = {
        draw: "icon",
        // methods: {
        //    click: function (item) {
        //        console.log(item);
        //     }
        // },
        zIndex: 100000,
        size: 50,
        width: this.cirSize * 8,
        height: this.cirSize * 8
        // sx: 10,
        // sy: 10,
        // swidth: 50,
        // sheight: 50,
      };
      this.dataSet = new mapv.DataSet([]); // 散点图层

      this.dataSetOff = new mapv.DataSet([]); // 散点图层(离线站点)

      this.quxianDataSet = new mapv.DataSet([]); // 区县色块图层
      this.jiezhenDataSet = new mapv.DataSet([]); // 街镇色块图层

      this.quxianNameDataSet = new mapv.DataSet([]); // 区县色块图层
      this.jiezhenNameDataSet = new mapv.DataSet([]); // 街镇色块图层

      this.currStationDataSet = new mapv.DataSet([]); // 选中圆圈图层
      this.currStationDataSetOff = new mapv.DataSet([]); // 选中圆圈图层(离线)

      this.gridNameDataSet = new mapv.DataSet([]);

      this.mapvLayer = new mapv.baiduMapLayer(map, this.dataSet, options);
      this.textMapLayer_high = new mapv.baiduMapLayer(
        map,
        this.dataSet,
        text_options_high
      );
      this.textMapLayerName = new mapv.baiduMapLayer(
        map,
        this.dataSet,
        text_options_name
      );

      this.mapvLayerOff = new mapv.baiduMapLayer(
        map,
        this.dataSetOff,
        optionOff
      );
      this.mapvLayerNameOff = new mapv.baiduMapLayer(
        map,
        this.dataSetOff,
        text_options_name
      );

      this.quxianNameMapLayer = new mapv.baiduMapLayer(
        map,
        this.quxianNameDataSet,
        region_text_options
      );
      this.jiezhenNameMapLayer = new mapv.baiduMapLayer(
        map,
        this.jiezhenNameDataSet,
        region_text_options
      );

      this.quxianMaplayer = new mapv.baiduMapLayer(
        map,
        this.quxianDataSet,
        options
      );
      this.jiezhenMaplayer = new mapv.baiduMapLayer(
        map,
        this.jiezhenDataSet,
        options
      );

      this.currStationMaplayer = new mapv.baiduMapLayer(
        map,
        this.currStationDataSet,
        options_circle
      );
      this.currStationMaplayerOff = new mapv.baiduMapLayer(
        map,
        this.currStationDataSetOff,
        options_circle
      );

      this.gridNameMaplayer = new mapv.baiduMapLayer(
        map,
        this.gridNameDataSet,
        grid_options_name
      );

      this.windRoseDirectionDataSet = new mapv.DataSet([]);
      this.windRoseDirectionLayer = new mapv.baiduMapLayer(
        map,
        this.windRoseDirectionDataSet,
        wind_options
      );

      this.windRoseSpeedDataSet = new mapv.DataSet([]);
      this.windRoseSpeedLayer = new mapv.baiduMapLayer(
        map,
        this.windRoseSpeedDataSet,
        wind_options
      );

      this.debouncedQuxian = this.$_.debounce(function() {
        this.quxianDataSet.set(this.poly_list);
        this.quxianNameDataSet.set(this.quxian_name_set);
      }, 50);

      this.debouncedjiezhen = this.$_.debounce(function() {
        this.jiezhenDataSet.set(this.poly_list_jiezhen);
        this.jiezhenNameDataSet.set(this.jiezhen_name_set);
      }, 50);

      this.textMapLayer_high.hide();
      this.textMapLayerName.hide();
      this.jiezhenNameMapLayer.hide();
      this.mapvLayerNameOff.hide();
      if (!this.showOff) {
        this.mapvLayerOff.hide();
      }
      this.map = map;
      this.$emit("map", this.map);
    },
    clickMapv(item) {
      if (item) {
        if (item.station) {
          if (
            item.station.station_id &&
            this.mapType == "point" &&
            !this.grid_fill
          ) {
            // this.$emit('openMapWindowStation',item.station)
            if (this.trackMode) {
              console.log('click track');
              this.chooseTrackerStation = item.station
              if (this.trackCustomTimeMode) {
                this.stiltLayer.getData(this.chooseTrackerStation, this.trackCustomTimeMode, this.trackTimeRange, this.trackTimeMode)
              }else {
                this.stiltLayer.getData(item.station, this.trackCustomTimeMode, this.line_t, this.trackTimeMode)
                this.aermodLayer.getData(this.chooseTrackerStation, this.line_t, this.aermodRoundType, this.aermodCircleRound)
              }
            }else {
              this.openMapWindowStation(item.station);
            }
          }
          if (item.station.level == 2 && this.mapType == "quxian") {
            this.$emit("openMapWindowRegion", item.station);
          }
          if (item.station.level == 3 && this.mapType == "jiezhen") {
            this.$emit("openMapWindowRegion", item.station);
          }
        }
      }
    },
    parentControlClose() {
      this.dialogSuyuanVisible = false;
    },
    updateGf() {
      let self = this;
      let inten = null;
      if (this.colorBarId != 3) {
        inten = this.intensity;
      }
      for (let i of this.gf_point_list) {
        this.map.removeOverlay(i);
        this.map.removeOverlay(i.circleMarker);
      }
      for (let i of this.gfData) {
        let val = i.data[this.data_type];
        if (this.showGfOutline) {
          let m = addMarker(
            i,
            this.dataType,
            this.map,
            val,
            inten,
            this.showGFName,
            this.isShowCircle,
            this.circleR,
            this.isPollution
          );
          m.addEventListener("click", function(i) {
            self.dialogSuyuanVisible = true;
            self.gf_sn = i.target.info.sn;
            self.gf_name = i.target.info.name;
            self.gf_level = i.target.info.station_level;
            console.log(i.target.info);
          });
          this.gf_point_list.push(m);
        } else {
          // 备注：增加标站污染指数---值等于null的为离线标站，值等于0的为在线没有污染的标站
          if (this.isPollution) {
            if (val >= 0) {
              let m = addMarker(
                i,
                this.dataType,
                this.map,
                val,
                inten,
                this.showGFName,
                this.isShowCircle,
                this.circleR,
                this.isPollution
              );

              this.gf_point_list.push(m);
            }
          } else {
            if (val > 0 && val) {
              let m = addMarker(
                i,
                this.dataType,
                this.map,
                val,
                inten,
                this.showGFName,
                this.isShowCircle,
                this.circleR,
                this.isPollution
              );
              m.addEventListener("click", function(i) {
                self.dialogSuyuanVisible = true;
                self.gf_sn = i.target.info.sn;
                self.gf_name = i.target.info.name;
                self.gf_level = i.target.info.station_level;
                console.log(i.target.info);
              });
              this.gf_point_list.push(m);
            }
          }
        }
      }
    },
    openMapWindowStation(station) {
      let p = new BMap.Point(station.Lng, station.Lat);
      let zoom = this.map.getZoom();
      if (zoom < 15) {
        zoom = 15;
      }
      this.map.centerAndZoom(p, zoom);
      this.station_dialog_type = "station";
      this.chooseStation = station;
      // this.chooseStationChart = [station]
      console.log("chooseStationChartChange");
      this.$emit("chooseStationChartChange", station);
      this.$emit("onchange", "aa");
      let params = {
        map: this.map,
        point: p,
        station: station,
        city: this.projectInfo.name,
        timeType: this.time_type,
        dataType: this.data_type,
        showChilds: this.showChilds,
        valueTime: this.timeRange,
        calied_type: this.calied_type,
        loadSnapStatus: this.loadSnapStatus,
      };
      if (this.showWind) {
        params.wind = 1;
      }
      openStationWindow(params);
      // this.showBigStationDialog = true
    },
    changeMapColor(colorType, colorRange, colorBar) {
      this.colorType = colorType;
      this.range_color = colorRange;
      if (colorBar != undefined) {
        this.colorBarId = colorBar;
      }
      let range = colorRange[this.data_type.slice(0, 4)];
      if (!range) {
        range = colorRange.pm25;
      }
      // range.push({start:0, end:1,value:'#67ce0b'})
      let option = {
        splitList: range,
        draw: colorType
      };
      // let min = 0
      // let max = 700
      // if (colorRange.type == 'color2'){
      //   min = this.min
      //   max = this.max
      // }
      if (colorType == "intensity") {
        let color = {};
        for (let i of range) {
          color[i.r] = i.c;
        }

        option = {
          min: this.min,
          max: this.max,
          draw: "intensity",
          gradient: color
        };
      }

      if (this.barMode == "pm10_pm25") {
        option = {
          splitList: split_color_pm10_pm25,
          draw: "choropleth"
        };
      }
      this.mapvLayer.update({ options: option });
      this.updateTextColor();
      this.quxianMaplayer.update({ options: option });
      this.jiezhenMaplayer.update({ options: option });
      this.updateGf();
      this.updatePolluteSourceLayer();
    },
    pointLayers(show = true) {
      if (show) {
        this.mapvLayer.show();
        if (this.showCurrentStation) {
          this.currStationMaplayer.show();
        }
        if (this.showOff) {
          this.mapvLayerOff.show();
          if (this.showCurrentStation) {
            this.currStationMaplayerOff.show();
          }
        }
        this.changeCirSize();
        this.drawMap();
      } else {
        this.mapvLayer.hide();
        this.textMapLayer_high.hide();
        this.textMapLayerName.hide();
        this.mapvLayerOff.hide();
        this.mapvLayerNameOff.hide();
        this.currStationMaplayer.hide();
        this.currStationMaplayerOff.hide();
      }
    },
    changeCirSize() {
      this.cirSize = zoomCircleSize[this.zoom];
      if (this.mapType == "point") {
        if (this.zoom >= 14) {
          if (!this.showWz) {
            this.textMapLayer_high.hide();
            this.textMapLayerName.hide();
            this.mapvLayerNameOff.hide();
          } else {
            this.textMapLayer_high.show();
            if (this.showName) {
              this.textMapLayerName.show();
              if (this.showOff) {
                this.mapvLayerNameOff.show();
              }
            }
          }
        } else {
          this.textMapLayer_high.hide();
          if (this.showName) {
            this.textMapLayerName.hide();
          }
          if (this.showOff) {
            this.mapvLayerNameOff.hide();
          }
        }
      }
      if (this.mapType == "jiezhen") {
        if (this.mapType == "jiezhen") {
          if (this.zoom >= 12) {
            this.jiezhenNameMapLayer.show();
          } else {
            this.jiezhenNameMapLayer.hide();
          }
        }
      }
    },
    drawMap() {
      let t1 = new Date().getTime();
      let self = this;
      let draw_data = [];
      let draw_data_off = [];
      let count = 0;
      let data_time = 0;
      if (!this.showWz) {
        this.mapvLayer.hide();
        this.textMapLayer_high.hide();
        this.textMapLayerName.hide();
        this.mapvLayerNameOff.hide();
        return;
      } else {
        if (this.zoom >= 14) {
          this.textMapLayer_high.show();
          if (this.showName) {
            this.textMapLayerName.show();
          }
        }
        if (this.showOff) {
          this.mapvLayerNameOff.show();
        }
      }
      if (this.draw_data.length == 0 || this.time_type != "real") {
        let data_type = "";
        if (this.data_type.includes("channels")) {
          data_type = this.channels;
        } else {
          data_type = this.data_type;
        }
        let typeInfo = G_SENSOR_DATA_TYPE_INFO.find(
          item => item.value === data_type
        );
        let decimal = 1;
        if (typeInfo) {
          decimal = typeInfo.decimal;
        }
        for (let p of this.mapData) {
          let lng = p.Lng;
          let lat = p.Lat;
          let val = p.data[data_type];
          if (decimal) {
            const pow = Math.pow(10, decimal) || 0;
            val = val ? Math.round(val * pow) / pow : val;
          }
          if (p.data.time > data_time) {
            data_time = p.data.time;
          }
          let point_size = 1;
          if (data_type == "pm10_p") {
            let pm25 = p.data.pm25;
            let pm10 = p.data.pm10_p;
            val = pm10;
            point_size = Math.round((pm10 / pm25) * 100) / 100;
          }
          let d_name = {
            geometry: {
              type: "Point",
              coordinates: [lng, lat]
            },
            count: val,
            text: p.name,
            point_size: point_size,
            station: p
          };
          if (data_type == "pm10_PoP") {
            if (!isCheckNumber(val)) {
              draw_data_off.push(d_name);
            } else {
              count += 1;
              draw_data.push(d_name);
            }
          } else {
            if (val == -1 || val == null) {
              draw_data_off.push(d_name);
            } else {
              count += 1;
              draw_data.push(d_name);
            }
          }
        }
        this.count = count;
        this.draw_data = draw_data;
        this.draw_data_off = draw_data_off;
        // 传递离线站点，用于风玫瑰图数量与站点数量对应
        const offStations = draw_data_off.map(item =>
          String(item.station.station_id)
        );
        this.$emit("update:offStations", offStations);
        let t_set1 = new Date().getTime();
        this.dataSet.set(this.draw_data);
        let t_set2 = new Date().getTime();
        this.dataSetOff.set(this.draw_data_off);
        let point_size_enable = 0;
        if (data_type == "pm10_p") {
          point_size_enable = 1;
        }
        this.mapvLayer.update({
          options: {
            point_size_enable: point_size_enable
          }
        });
        this.mapvLayer.show();
        window.mapvLayer = this.mapvLayer;
        this.changeMapColor(this.colorType, this.range_color);
        let t2 = new Date().getTime();
        console.log("draw map end", t2 - t1);
        this.$emit("drawFinished", 1);
      } else {
        this.updateMap();
      }
      this.drawCurrentStation();
      this.$emit("loadmap", "1");
    },
    updateMap() {
      let t1 = new Date().getTime();
      var self = this;
      let draw_data = [];
      let count = 0;
      let data_time = 0;
      let data = this.mapData;
      if (this.time_type == "real") {
        data = this.realData;
      }

      for (let p of data) {
        if (p.data.time > data_time) {
          data_time = p.data.time;
        }
        let val = p.data[this.data_type];
        let old_p = this.$_.find(this.draw_data, function(x) {
          return x.station.station_id == p.station_id;
        });
        if (!old_p) {
          continue;
        }
        old_p.count = val;
        if (!val || val < 0) {
          continue;
        } else {
          count += 1;
        }
      }
      this.cur_time = getTimeByType(data_time, this.time_type);
      this.count = this.$_.filter(this.draw_data, function(x) {
        return x.count > 0;
      }).length;
      this.changeMapColor(this.colorType, this.range_color);
      this.mapvLayer.draw();
      this.textMapLayer_high.draw();
      let t2 = new Date().getTime();
      console.log("update map end", t2 - t1);
    },

    // 风场

    windLayerChange() {
      console.log("windLayerChange");
      if (this.showWindLayer) {
        this.getWindData();
      } else {
        if (this.windLayer) {
          // this.windLayer.clear()
          // this.map.removeOverlay(this.windLayer)
          this.windLayer.hide();
        }
      }
    },
    updateGridInterpImg() {
      if (this.showGridInterpImg) {
        if (!this.groundOverlay) {
          var SW = new BMap.Point(116.20,35.90);
          var NE = new BMap.Point(118.00,37.70);
          var groundOverlayOptions = {
            opacity: this.gridInterpImgTransparency,
          }
          // 初始化GroundOverlay
          var groundOverlay = new BMap.GroundOverlay(new BMap.Bounds(SW, NE), groundOverlayOptions);
          this.groundOverlay = groundOverlay
          this.map.addOverlay(groundOverlay);
        }
        // 设置GroundOverlay的图片地址
        // /${this.time_type}
        this.groundOverlay.setImageURL(`http://jnwz.novaecs.com/167/model/code/Generate_Figs/${this.data_type}/${this.$moment(this.line_t).format('YYYY-MM-DDTHH:mm:ss')}.png`);
      }else {
        if (this.groundOverlay) {
          this.map.removeOverlay(this.groundOverlay);
          this.groundOverlay = null
        }
      }
    },
    async updatePolluteSourceLayer() {
      for (let i of this.pollute_source_list) {
        this.map.removeOverlay(i);
      }
      this.map.closeInfoWindow();
      let self = this
      let inten = null;
      if (this.colorBarId != 3) {
        inten = this.intensity;
      }
      this.pollute_source_list = [];
      if (this.data_type == "pm25" || this.data_type == "pm10") {
        if (this.showPolluteSourceLayer) {
          try {
            let res = await getRecent24hourPolluteSource(this.data_type)
            let data = res.data;
            this.polluteSourceData = data
            for(let i = 0; i < 10; i++) {
              let val = data[i][1];

              let m = addMarker(
                {Name: '污染源' + (i + 1), Lng: data[i][0][0], Lat: data[i][0][1]},
                this.dataType,
                this.map,
                val,
                inten,
                true,
                false,
                0,
                false
              );
              m.addEventListener('click', function(e) {
                const info = e.target.info;
                const opts = {
                  width: 0, // 信息窗口宽度
                  height: 0, // 信息窗口高度
                  title: '', // 信息窗口标题
                  offset: new BMap.Size(0, -35)
                };
                const content = 
                  `<div>
                    <div>${info.Name}: ${val}</div>
                    <div>经度：${info.Lng}</div>
                    <div>纬度：${info.Lat}</div>
                  </div>`
                const infoWindow = new BMap.InfoWindow(content, opts);
                const point = new BMap.Point(info.Lng, info.Lat);
                self.map.openInfoWindow(infoWindow, point);
              });
              
              this.pollute_source_list.push(m);
            }
            
          } catch (error) {
            console.log(error);
          }
        }
      }
    },
    exportPollutionGrid() {
      var content = [`序号, 经度, 纬度, 数值\n`];
      let i = 0
    	for (let info of this.polluteSourceData){
        let text = `${parseInt(i)+1}, ${info[0][0]}, ${info[0][1]}\t, ${info[1]}\n`
    		content.push([text])
        i ++ 
    	}
    	var file_name = '污染源'
      var blob = new Blob(content, { type: "text/plain;charset=utf-8" });
      FileSaver.saveAs(blob, file_name + ".csv");
    },
    getWindData() {
      let line_t = this.line_t;
      // line_t = getWindRecentTime(line_t)
      let t = line_t;
      // if (this.last_wind_t == line_t){
      //   return
      // }
      if (this.windLayer) {
        // this.windLayer.clear()
        // this.map.removeOverlay(this.windLayer)
        this.windLayer.hide();
      }

      this.last_wind_t = line_t;
      let time_type = this.time_type;
      if (time_type == "min") {
        time_type = "hour";
      }

      getWindFromEarth(this.projectInfo.name, t, this.gf_stations).then(x => {
        let units = "degrees";
        // // kilometers
        // if (t > 1567677600000) {
        //   units = 'kilometers'
        // }
        let windLayer = drawWindLayer(this.map, x, [this.windColor], units);
        this.windLayer = windLayer;
        window.windLayer = this.windLayer;
      });
    },

    // 走航
    getCarLayer() {
      if (this.showCarLayer) {
        let colormap_dyn_type = "static";
        // if (this.map_option.colorRange.type == 'color2'){
        //   z = 'dynamic'
        // }
        if (this.colorBarId == 2) {
          colormap_dyn_type = "dynamic";
        }
        if (this.tileLayer) {
          this.map.removeTileLayer(this.tileLayer);
        }
        this.tileLayer = drawTile(
          this.zhGroupInfo.zh_host,
          this.map,
          this.dataTypePm,
          this.zhGroupInfo.zh_group_id,
          this.line_t,
          this.time_type,
          colormap_dyn_type,
          this.car_point_filter,
          this.min,
          this.max
        );
      } else {
        this.map.removeTileLayer(this.tileLayer);
      }
    },

    // 网格
    initGrid(fill = true) {
      this.quxianMaplayer.hide();
      this.jiezhenMaplayer.hide();
      this.jiezhenNameMapLayer.hide();
      this.quxianNameMapLayer.hide();
      this.removeGrid(this.canvasLayer);
      this.map.addEventListener("click", this.openGridInfo);
      this.grid_fill = fill;
      this.canvasLayer = new CanvasLayer({
        map: this.map,
        update: this.update,
        zIndex: 1
      });
      this.ctx = this.canvasLayer.canvas.getContext("2d");
      if (this.grids.grid3.length == 0) {
        getGrids().then(x => {
          this.grids1 = x.grid1;
          this.grids3 = x.grid3;
          this.gridFillData(fill);
        });
      } else {
        this.gridFillData(fill);
      }
    },
    update() {
      let grid_info = drawGrid(
        this.grids,
        this.map,
        this.ctx,
        this.data_type,
        this.grid_fill,
        this.showGridName,
        this.zoom,
        this.cirSize,
        this.grid_zoom_change,
        this.gridOpacity / 100,
        this.chooseGrid
      );
      this.all_grid = grid_info.all_grid;
    },
    removeGrid() {
      if (this.canvasLayer) {
        this.map.removeEventListener("click", this.openGridInfo);
        this.map.removeOverlay(this.canvasLayer);
        this.grid_fill = false;
      }
    },
    fillGrid(grid_data) {
      let data_time = 0;
      for (let g of grid_data) {
        if (!g.childs) {
          g[this.data_type] = -1;
          continue;
        }
        let childs = g.childs.split(",");
        let grid_data = [];
        let time = 0;
        for (let c of childs) {
          let station_data = this.$_.find(this.mapData, function(x) {
            return x.station_id == c;
          });
          if (!station_data) {
            continue;
          }
          time = station_data.data.time;
          if (data_time < time) {
            data_time = time;
          }
          grid_data.push(station_data.data[this.data_type]);
        }
        g[this.data_type] = Math.round(this.$_.mean(grid_data));
        g.time = data_time;
        this.cur_time = getTimeByType(data_time, this.time_type);
      }
    },
    gridFillData(fill) {
      if (fill) {
        this.fillGrid(this.grids1);
        this.fillGrid(this.grids3);
      }
      let grid_info = drawGrid(
        this.grids,
        this.map,
        this.ctx,
        this.data_type,
        this.grid_fill,
        this.showGridName,
        this.zoom,
        this.cirSize,
        this.grid_zoom_change,
        this.gridOpacity / 100,
        this.chooseGrid
      );
      this.all_grid = grid_info.all_grid;
    },
    openGridInfo(r) {
      // if (this.mapType != 'grid'){
      //   return
      // }
      var lng = r.point.lng;
      var lat = r.point.lat;
      var grid_list = [];
      if (this.grids.grid5) {
        grid_list.push(this.grids.grid5);
      }
      if (this.grids.grid1) {
        grid_list.push(this.grids.grid1);
      }
      if (this.grids.grid3) {
        grid_list.push(this.grids.grid3);
      }
      for (var i of this.all_grid) {
        if (lng < i[0] && lng > i[1] && lat < i[2] && lat > i[3]) {
          for (let grids of grid_list) {
            let choose_grid = this.$_.find(grids, function(x) {
              return x.id == i[4];
            });
            if (!choose_grid) {
              continue;
            }
            this.$emit("openMapWindowGrid", choose_grid);
            console.log(choose_grid);
            let r = 1;
            if (choose_grid.large_grid_box) {
              r = 5;
            }

            if (r == 1) {
              this.grid1_child = this.$_.filter(this.grids1, x => {
                return x.large_grid_box == choose_grid.name;
              });
            } else {
              // this.grid5_child = choose_grid
            }
            // break;
            return;
          }
        }
      }
    },
    // 标记当前点
    drawCurrentStation() {
      if (!this.showCurrentStation) {
        // this.currStationMaplayer.hide()
        return;
      }
      console.log("drawCurrentStation");
      let datas = [];
      let datas_off = [];
      for (let i of this.chooseStationChart) {
        let if_off = this.$_.find(this.draw_data_off, function(x) {
          return x.station.station_id == i.station_id;
        });
        let is_online = this.$_.find(this.draw_data, function(x) {
          return x.station.station_id == i.station_id;
        });
        if (!is_online && !if_off) continue;
        let data_set = {
          geometry: {
            type: "Point",
            coordinates: [i.Lng, i.Lat]
          },
          count: 30
        };

        if (if_off) {
          datas_off.push(data_set);
        } else {
          datas.push(data_set);
        }
      }
      this.currStationDataSetOff.set(datas_off);
      this.currStationDataSet.set(datas);
      this.currStationMaplayer.update({
        options: {
          size: this.cirSize + 2
        }
      });
      this.currStationMaplayerOff.update({
        options: {
          size: this.cirSize + 2
        }
      });
      if (this.showOff) {
        this.currStationMaplayerOff.show();
      } else {
        this.currStationMaplayerOff.hide();
      }
      this.currStationMaplayer.show();
    },

    updateTextColor() {
      console.log("update text color");
      text_options_high.intensityCustom = this.intensity;
      region_text_options.intensityCustom = this.intensity;
      grid_options_name.intensityCustom = this.intensity;
      this.quxianMaplayer.update(region_text_options);
      this.jiezhenMaplayer.update(region_text_options);
      this.textMapLayer_high.update(text_options_high);
    },
    openMapWindowOut(station_id, name, lng, lat, t, timeType, childs) {
      openMapWindow(station_id, name, lng, lat, this.map, t, timeType, childs);
    },
    getRegions(type) {
      var self = this;
      let region_data = this.quxianData;
      if (type == "jiezhen") {
        region_data = this.jiezhenData;
      }
      for (let i of region_data) {
        let region_id = i.region_id;
        let data = this.$_.find(region_data, function(x) {
          return x.region_id == region_id;
        });
        let val = data.data[this.data_type];
        getRegion(region_id).then(x => {
          for (let d of x.data[0].data) {
            let child_d = [];
            for (let r of d) {
              let gcj = coordtransform.wgs84togcj02(r[0], r[1]);
              let bd = coordtransform.gcj02tobd09(gcj[0], gcj[1]);
              child_d.push([bd[0], bd[1]]);
            }

            let data_set = {
              geometry: {
                type: "Polygon",
                coordinates: [child_d]
              },
              count: val,
              region_id: region_id,
              station: i
            };
            if (type == "quxian") {
              this.poly_list.push(data_set);
            } else {
              this.poly_list_jiezhen.push(data_set);
            }
          }
          let d_name = {
            geometry: {
              type: "Point",
              coordinates: [i.Lng, i.Lat]
            },
            text: i.name
          };
          if (type == "quxian") {
            this.quxian_name_set.push(d_name);
          } else {
            this.jiezhen_name_set.push(d_name);
          }
        });
      }
    },
    drawRegion(type = "quxian") {
      let poly_list = this.poly_list;
      let layer = this.quxianMaplayer;
      let hideLayer = this.jiezhenMaplayer;
      let nameLayer = this.quxianNameMapLayer;
      let hidenameLayer = this.jiezhenNameMapLayer;
      if (type == "jiezhen") {
        poly_list = this.poly_list_jiezhen;
        layer = this.jiezhenMaplayer;
        hideLayer = this.quxianMaplayer;
        nameLayer = this.jiezhenNameMapLayer;
        hidenameLayer = this.quxianNameMapLayer;
        this.updateRegionData("jiezhen");
      } else {
        this.updateRegionData("quxian");
      }
      layer.show();
      if (this.zoom > 12 || this.mapType == "quxian") {
        nameLayer.show();
      }
      setTimeout(hideLayer.hide(), 1000);
      setTimeout(hidenameLayer.hide(), 1000);
      if (poly_list.length == 0) {
        this.getRegions(type);
      }
    },
    updateRegionData(type = "quxian") {
      let region_data = this.quxianData;
      let poly_list = this.poly_list;
      let data_set = this.quxianDataSet;
      let layer = this.quxianMaplayer;
      if (type == "jiezhen") {
        region_data = this.jiezhenData;
        poly_list = this.poly_list_jiezhen;
        data_set = this.jiezhenDataSet;
        layer = this.jiezhenMaplayer;
      }
      let new_data_set = [];
      let data_time = 0;
      for (let i of region_data) {
        if (data_time < i.data.time) {
          data_time = i.data.time;
        }
        let old_d = this.$_.find(poly_list, function(x) {
          return x.region_id == i.region_id;
        });
        if (!old_d) {
          continue;
        } else {
          old_d.count = i.data[this.data_type];
        }
      }
      this.cur_time = getTimeByType(data_time, this.time_type);
      layer.draw();
    },
    drawWindRose(extra) {
      let moment_time = this.$moment(this.cur_time.split(" -- ")[0]);
      let year = moment_time.format("YYYY");
      let month = moment_time.format("MM");
      let day = moment_time.format("DD");
      let data = [];
      if (extra == "_direction") {
        var layer = this.windRoseDirectionLayer;
        var dataSet = this.windRoseDirectionDataSet;
        var confirm = this.showWindRoseMapDirection;
      } else {
        var layer = this.windRoseSpeedLayer;
        var dataSet = this.windRoseSpeedDataSet;
        var confirm = this.showWindRoseMapSpeed;
      }

      if (confirm) {
        for (let i of this.stations) {
          if (i.station_param != "六参数") {
            continue;
          }
          let img = new Image();
          img.src =
            this.$img_base_path +
            `${year}/${year}-${month}/${year}-${month}-${day}/${i.station_id}_${this.time_type}_${year}${month}${day}${extra}.png`;
          // img.src = 'https://jnwzhuabei2.oss-cn-beijing.aliyuncs.com/wind_rose_image/2019/2019-01/2019-01-01/930_day_20190101.png'
          // img.onload = function(){
          data.push({
            geometry: {
              type: "Point",
              coordinates: [i.Lng, i.Lat]
            },
            deg: 0,
            icon: img
          });
          // }
        }
        dataSet.set(data);
        var dataSet = new mapv.DataSet(data);
        var options = {
          draw: "icon",
          methods: {
            click: function(item) {
              console.log(item);
            }
          },
          zIndex: 100000,
          size: 50,
          width: this.cirSize * 8,
          height: this.cirSize * 8
          // sx: 10,
          // sy: 10,
          // swidth: 50,
          // sheight: 50,
        };
        // layer = new mapv.baiduMapLayer(this.map, dataSet, options);
        layer.draw();
        layer.show();
        // this.windRoseLayer = new mapv.baiduMapLayer(this.map, dataSet, options);
        // this.windRoseLayer.draw()
      } else {
        // this.windRoseLayer.hide()
        layer.hide();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MapView.vue